import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './Footer.module.scss';
import f1 from '~/assets/images/footer/f1.png';
import fb from '~/assets/images/footer/fb.png';
import zalo from '~/assets/images/footer/zalo.png';
import inst from '~/assets/images/footer/in.png';
import vinasa from '~/assets/images/footer/vinasa.png';
import { useTranslation } from 'react-i18next';

import axios from 'axios';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import API_URL from '~/config';

const cx = classNames.bind(styles);

function Footer() {
    const { i18n, t } = useTranslation();
    const [formData, setFormData] = useState({
        email: '',
    });

    const [isSending, setIsSending] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Kiểm tra validation
        if (!formData.email) {
            alert('Vui lòng điền đầy đủ thông tin.');
            return;
        }

        // Kiểm tra định dạng email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            alert('Email không hợp lệ.');
            return;
        }

        setIsSending(true);
        try {
            // Gửi dữ liệu biểu mẫu qua email
            const data = await axios.post(`${API_URL}/subcribe`, formData);
            // Đặt trạng thái hoặc thực hiện các hành động khác sau khi gửi email thành công
            if (data.status === 200) {
                alert(t('Email sent successfully'))
                setFormData({
                    email: '',
                });
            }
        } catch (error) {
            console.error('Error sending email:', error);
        } finally {
            setIsSending(false); // Kết thúc gửi
        }
    };
    return (
        <footer className={cx('footer')}>
            <div className={cx('footer__row')}>
                <div className={cx('footer__layout__one')}>
                    <div>
                        <Link to="/" style={{ textDecoration: 'none' }}>
                            <div className={cx('footer__layout__one-logo')} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                <img src={f1} alt="Logo" width={67} />
                                <span
                                    style={{
                                        fontSize: '26px',
                                        color: '#fff',
                                        fontWeight: '500',
                                        marginLeft: '10px',
                                        lineHeight: '1',
                                    }}
                                >
                                    Odyssey
                                </span>
                            </div>
                            <div
                                style={{
                                    marginTop: '13px',
                                    color: '#fff',
                                    fontSize: '14px',
                                    marginBottom: '20px',
                                    width: '204px',
                                    paddingLeft: '13px'
                                }}
                                className={cx('footer__layout__one-change')}
                            >
                                We change the world
                            </div>
                        </Link>
                    </div>

                    <div style={{ fontSize: '16px', color: 'rgb(138, 138, 138)', marginBottom: 9 }}>+84933621635</div>

                    <div style={{ fontSize: '16px', color: 'rgb(138, 138, 138)' }}>
                        support@odyssey.net.vn
                    </div>

                    {/* <div
                        style={{
                            fontSize: '16px',
                            color: 'rgb(138, 138, 138)',
                            lineHeight: '36px',
                        }}
                    >
                        {t('address1')}
                    </div>
                    <div
                        style={{
                            fontSize: '16px',
                            color: 'rgb(138, 138, 138)',
                            marginBottom: '25px',
                            lineHeight: '36px',
                        }}
                    >
                        {t('address2')}
                    </div> */}
                    <div
                        style={{
                            fontSize: '16px',
                            color: 'rgb(138, 138, 138)',
                            marginBottom: '23px',
                            lineHeight: '33px',
                        }}
                    >
                        {t('address')}
                    </div>

                    <div style={{ fontSize: '12px', color: 'rgb(138, 138, 138)' }}>{t('2021 Odyssey')}</div>
                </div>
                <div className={cx('footer__layout__two')}>
                    <ul className={cx('footer__layout__two__list')}>
                        <li className={cx('footer__layout__two__item')}>
                            <Link to="/"> {t('home')}</Link>
                        </li>
                        <li className={cx('footer__layout__two__item')}>
                            <Link to="/services"> {t('Services')}</Link>
                        </li>
                        <li className={cx('footer__layout__two__item')}>
                            <Link to="/solution"> {t('solution')}</Link>
                        </li>
                        <li className={cx('footer__layout__two__item')}>
                            <Link to="/mission"> {t('Misson')}</Link>
                        </li>
                        <li className={cx('footer__layout__two__item')}>
                            <Link to="/about-us"> {t('About us')}</Link>
                        </li>
                        <li className={cx('footer__layout__two__item')}>
                            <Link to="/contact"> {t('contact')}</Link>
                        </li>
                        <li className={cx('footer__layout__two__item')}>
                            <Link to="/profile"> {t('profile')}</Link>
                        </li>
                    </ul>
                </div>
                <div className={cx('footer__layout__three')}>
                    <div
                        style={{
                            fontSize: '18px',
                            color: 'rgb(138, 138, 138)',
                            marginBottom: '14px',
                            lineHeight: '40px',
                        }}
                    >
                        {t('Stay Up to Date with Odyssey')}
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <label
                                htmlFor="email"
                                style={{
                                    fontSize: '14px',
                                    color: 'rgb(138, 138, 138)',
                                    marginBottom: '10px',
                                }}
                            >
                                Email *
                            </label>
                            <input
                                type="email"
                                id="email"
                                style={{
                                    width: '279px',
                                    height: '55px',
                                    marginBottom: '13px',
                                    backgroundColor: 'transparent',
                                    borderRadius: '5px',
                                    padding: '0 10px',
                                    fontSize: '14px',
                                    color: 'rgb(138, 138, 138)',
                                    outline: 'none',
                                    border: '1px solid rgb(138, 138, 138)',
                                }}
                                name='email' value={formData.email} onChange={handleChange}
                            />
                            <button type="submit" disabled={isSending}>
                                {isSending ? <AiOutlineLoading3Quarters className={cx('spinner')} /> : 'Subscribe'}
                            </button>
                        </div>
                    </form>
                </div>
                <div className={cx('footer__layout__four')}>
                    <div className={cx('icon-mobile')}>
                        <div
                            style={{
                                fontSize: '18px',
                                color: 'rgb(138, 138, 138)',
                                marginRight: '24px'
                            }}
                        >
                            {t('Follow Us')}
                        </div>
                        <div>
                            <Link
                                to="#"
                                style={{
                                    marginRight: '10px',
                                }}
                            >
                                <img src={inst} alt="LinkedIn" />
                            </Link>
                            <Link
                                to="#"
                                style={{
                                    marginRight: '10px',
                                }}
                            >
                                <img src={fb} alt="Facebook" />
                            </Link>
                            <Link
                                to="#"
                                style={{
                                    marginRight: '10px',
                                }}
                            >
                                <img style={{ borderRadius: '50%' }} src={zalo} alt="Zalo" />
                            </Link>
                        </div>
                        <div className={cx('footer__member-of')}>
                            <div className={cx('footer__member-of__title')}>{t('Member of')}</div>
                            <a href='https://vinasa.org.vn' >
                                <img src={vinasa} width={65} alt='Vinasa' />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;